import coverPhoto from '../assets/hotspot/celebrationCover/Yalda.jpg';
import azizamToGolakamiImage from '../assets/hotspot/celebrationPerformances/azizam_to_golakami_learn.jpg';
import mehramImage from '../assets/hotspot/headerImages/mehram-s.jpg';
import celebrationThumbnail from '../assets/hotspot/celebrationPerformances/Mehrnam_concert.jpg.jpeg';
import bolandBaalaaLearnImage from '../assets/hotspot/celebrationPerformances/Boland_Baalaa_learn .jpg';
import bolandBaalaaImage from '../assets/hotspot/celebrationPerformances/mehrnam_boland_baalaa_concert.png';

export const yalda = {
  celebrationTitle: 'Yalda',
  startDate: '12-20',
  endDate: '12-21',
  filterValue: 'yalda',
  displayDate: 'December 20-21',
  celebrationImage: coverPhoto,
  description: 'Yalda is an ancient Persian festival celebrating the winter solstice. On the longest night of the year, Iranians eat, drink, read poetry, and stay up past midnight. Yalda celebrations often feature watermelons and pomegranates, which are said to protect observers from falling ill in the winter.',
  celebrationVideos: [
    {
      videoLink: 'https://vimeo.com/1105194766?fl=pl&fe=sh',
      videoImage: azizamToGolakamiImage,
      songTitle: 'Azizam To Golakami',
      artistName: 'Mehrnam',
      videoTags: [
        {
          tag: 'Yalda',
        },
        {
          tag: 'Nowruz',
        },
      ],
      songDescription: '"Azizam To Golakami" ("My Dear, My Flower") is a traditional Kurdish folk song that originates from the Kurdish region of Iran. The song reflects the intimate connection between people and the natural world, focusing on the beauty of natures, especially flowers.',
    },
    {
      videoLink: 'https://vimeo.com/1105196690?fl=pl&fe=vl',
      videoImage: celebrationThumbnail,
      songTitle: 'Azizam To Golakami',
      artistName: 'Mehrnam',
      videoTags: [
        {
          tag: 'Yalda',
        },
        {
          tag: 'Nowruz',
        },
      ],
    },
    {
      videoLink: 'https://vimeo.com/1105195705?fl=pl&fe=sh',
      videoImage: bolandBaalaaLearnImage,
      songTitle: 'Boland Baalaa',
      artistName: 'Mehrnam',
      videoTags: [
        {
          tag: 'Yalda',
        },
        {
          tag: 'Chaharshanbeh Suri',
        },
      ],
      songDescription: '"Boland Baalaa" ("Tall and Pretty") is a song from the Khorasan region in northeastern Iran. The song refers to the experience and feelings of being far away from a loved one, whether in spatial distance or emotional distance, reminding us how much someone can care for another person.',
    },
    {
      videoLink: 'https://vimeo.com/1105197090?fl=pl&fe=vl',
      videoImage: bolandBaalaaImage,
      songTitle: 'Boland Baalaa',
      artistName: 'Mehrnam',
      videoTags: [
        {
          tag: 'Yalda',
        },
        {
          tag: 'Chaharshanbeh Suri',
        },
      ],
    },
  ],
  artistsWhoCelebrate: [
    {
      artistName: 'Mehrnam',
      artistImage: mehramImage,
    },
  ],
};
